import * as NutrSpecService from "../../services/nutrSpecList/nutritionalSpecListService";
import { queryClient } from "../../services/utils";

const state = {
 nutrSpecsLists: [],
 selectedList: null,
 totalLists: 0,
};

const mutations = {
 SET_NUTR_SPEC_LISTS(state, items) {
  state.nutrSpecsLists = items;
 },

 SET_SELECTED_LIST(state, selectedList) {
  state.selectedList = selectedList;
 },

 SET_SELECTED_LIST_CHANGED(state, value) {
  state.selectedList = { ...state.selectedList, is_changed: value };
 },

 REMOVE_NUTR_SPEC_ITEM_FROM_SELECTED_LIST(state, id) {
  const itemIndex = state.selectedList.nutritional_specs.findIndex(item => item.id === id);
  state.selectedList.nutritional_specs.splice(itemIndex, 1);
 },

 UPDATE_SELECTED_LIST_NAME(state, name) {
  state.selectedList.name = name;
 },

 UPDATE_SELECTED_LIST_EFCR(state, fft_efcr) {
  state.selectedList.fft_efcr = fft_efcr;
 },

 UPDATE_SELECTED_LIST_PRODUCTION_MT(state, fft_production_mt) {
  state.selectedList.fft_production_mt = fft_production_mt;
 },

 UPDATE_SELECTED_LIST_PRODUCTION_CF(state, fft_production_cf) {
  state.selectedList.fft_production_cf = fft_production_cf;
 },

 SET_TOTAL_LISTS(state, totalLists) {
  state.totalLists = totalLists;
 },
};

const actions = {
 resetCache({ dispatch }) {
  queryClient.removeQueries(["FETCH_NUTR_SPEC_LISTS"], { exact: false });
  dispatch("fftList/clearCachedFftData", null, { root: true });
 },

 async createNutrSpecList({ commit, dispatch }, requestBody) {
  try {
   const response = await NutrSpecService.createNutrSpecList(requestBody);

   if (response.status === 200) {
    let i = state.nutrSpecsLists.findLastIndex(x => x.is_pinned) + 1;
    const nutrSpecLists = state.nutrSpecsLists.toSpliced(i, 0, response.data.data);
    commit("SET_NUTR_SPEC_LISTS", nutrSpecLists);
    dispatch("resetCache");
   }
   return response;
  } catch (e) {
   console.error(e);
  }
 },

 async createNutrSpecListCopy({ commit, dispatch }, { listId, requestBody }) {
  try {
   const response = await NutrSpecService.createNutrSpecListCopy(listId, requestBody);

   if (response.status === 200) {
    let i = state.nutrSpecsLists.findLastIndex(x => x.is_pinned) + 1;
    const nutrSpecLists = state.nutrSpecsLists.toSpliced(i, 0, response.data.data);
    commit("SET_NUTR_SPEC_LISTS", nutrSpecLists);
    dispatch("resetCache");
   }

   return response;
  } catch (e) {
   console.error(e);
  }
 },

 updateListInNutrSpecLists({ commit, dispatch }, nutrSpecList) {
  const nutrSpecLists = [...state.nutrSpecsLists];
  const listIndex = nutrSpecLists.findIndex(list => list.id === nutrSpecList.id);
  nutrSpecLists[listIndex] = nutrSpecList;

  commit("SET_NUTR_SPEC_LISTS", nutrSpecLists);
  if (state.selectedList && state.selectedList.id === nutrSpecList.id) {
   commit("SET_SELECTED_LIST", nutrSpecList);
  }
  dispatch("resetCache");
 },

 async updateNutritionalSpecList({ commit, dispatch }, { listId, requestBody }) {
  try {
   const response = await NutrSpecService.updateNutritionalSpecList(listId, requestBody);
   if (response.status === 200) {
    dispatch("updateListInNutrSpecLists", response.data.data);
    dispatch("resetCache");
   }
   return response;
  } catch (e) {
   console.error(e);
  }
 },

 async fetchNutrSpecList({ dispatch }, { nutrSpecListId }) {
  try {
   const response = await NutrSpecService.fetchNutrSpecList(nutrSpecListId);

   if (response.status === 200) {
   }

   return response;
  } catch (error) {
   console.error(error);
  }
 },

 async fetchNutrSpecLists({ commit, state }, options = {}) {
  const { page = 1, limit = 10, query = "" } = options;

  // check the cache first

  const cachedData = queryClient.getQueryData(["FETCH_NUTR_SPEC_LISTS", { page, limit, query }], { active: true });
  if (cachedData) {
   commit("SET_NUTR_SPEC_LISTS", cachedData?.data?.data);
   commit("SET_TOTAL_LISTS", cachedData?.data?.total);

   return cachedData;
  }

  try {
   const response = await queryClient.fetchQuery(["FETCH_NUTR_SPEC_LISTS", { page, limit, query }], NutrSpecService.fetchNutrSpecLists, {
    refetchOnMount: false,
   });

   const nutrSpecLists = response.data.data;
   const total = response.data.total;

   commit("SET_NUTR_SPEC_LISTS", nutrSpecLists);
   commit("SET_TOTAL_LISTS", total);

   if (nutrSpecLists.length && state.selectedList) {
    const selectedList = nutrSpecLists.find(item => item.id === state.selectedList.id);
    commit("SET_SELECTED_LIST", selectedList);
   }

   return response;
  } catch (error) {
   console.error(error);
  }
 },

 async updateNutrSpecs({ commit, dispatch }, { nutrSpecListId, requestBody }) {
  try {
   const response = await NutrSpecService.updateNutrSpecs(nutrSpecListId, requestBody);

   if (response.status === 200) {
    dispatch("updateListInNutrSpecLists", response.data.data);
    dispatch("resetCache");
   }

   return response;
  } catch (e) {
   console.error(e);
  }
 },

 async syncNutritionalSpecs({ commit, dispatch }, {}) {
  try {
   const response = await NutrSpecService.syncNutritionalSpecs(state.selectedList.id);

   if (response.status === 200) {
    commit("SET_SELECTED_LIST", response.data.data);
    dispatch("resetCache");
   }
   return response;
  } catch (e) {
   console.error(e);
  }
 },

 updateSelectedList({ commit }, item) {
  commit("SET_SELECTED_LIST", item);
 },

 removeNutritionalSpecItem({ commit, dispatch }, { id }) {
  commit("REMOVE_NUTR_SPEC_ITEM_FROM_SELECTED_LIST", id);
  dispatch("isSelectedListChanged", true);
 },

 isSelectedListChanged({ commit, dispatch }, value) {
  commit("SET_SELECTED_LIST_CHANGED", value);
 },

 async removeNutritionalSpecList({ dispatch, commit }, listId) {
  const response = await NutrSpecService.deleteNutritionalSpecList(listId);
  if (response.status === 200) {
   const nutrSpecLists = state.nutrSpecsLists.filter(item => item.id !== listId);
   commit("SET_NUTR_SPEC_LISTS", nutrSpecLists);
   dispatch("resetCache");
  }
 },
};

const getters = {
 getNutrSpecLists: state => state.nutrSpecsLists,
 getSelectedList: state => state.selectedList,
 getTotalLists: state => state.totalLists,
};

export default {
 namespaced: true,
 state,
 getters,
 actions,
 mutations,
};
